import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';

const icons = {
  SpaceDashboardIcon
};

const dashboard = {
  id: 'group-dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.SpaceDashboardIcon,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
